import defer from 'lodash/defer';
import once from 'lodash/once';

import { composeSubscriber } from '../module';
import { routerActionCreators } from '../state';

const dispatchInitialLocation = (history, ready: Promise<any>) =>
  composeSubscriber({
    selector: () => null,
    onChange: once(async () => {
      return ready
        .then(() => {
          defer(() => {
            routerActionCreators.readyForRoutes();
            routerActionCreators.locationChanged({ location: history.location });
          });
        })
        .catch((e) => {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.log('Error reaching ready state', e);
          }
        });
    })
  });

export const initializeCurrentLocation = (history, ready: Promise<any>) => {
  return dispatchInitialLocation(history, ready || Promise.resolve());
};
